import React, { useEffect, useState } from 'react'
import ActionBar from '../actionBar'
import { genderList } from '../../utils/constants'
import DashboardsTopDropDowns from '../CustomComponents/DashboardsTopDropDowns'
import TopCard from '../TopCard'
import { Box, Button, Checkbox, Chip, Grid, Popover, Typography } from '@mui/material'
import { Donegreen, green, hMapBlue, headingBlue, maroon, orange, pureWhite, red, seaGreen, yellowish } from '../../assets/colors'
import { leadResponse, leadStatus } from '../../utils/constants'
import { fetchSHDHLeads, getCallerPerformance, getSHDHTopWidget } from '../../backend/backendApis'
import { useSelector } from 'react-redux'
import HttpService from '../../backend/requestApis'
import ChapterLeadsTable from './ChapterLeadsTable'
import './ChapterLeads.css'
import { buttonStyle } from '../../utils/commonCSS'
import LeadTemplates from './LeadTemplates/LeadTemplates'
import { useNavigate } from 'react-router-dom'
import Loader from '../Loader'
import HBChart from '../CustomHorizontalBarChart/HBChart'
import { CropSquareSharp } from '@mui/icons-material'

const ChapterLeads = () => {

  const navigate = useNavigate()

  const districts = useSelector(state => state.selectedDistricts.selectedDistricts)
  const gender = useSelector(state => state.selectedGender.selectedGender)

  const [templateDialogStatus, setTemplateDialogStatus] = useState(false)

  const [leadsData, setLeadsData] = useState({})
  const [page, setPage] = useState(1)
  const [offset, setOffset] = useState(10)
  const [tableRefresh, setTableRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isTopWidgetLoading, setIsTopWidgetLoading] = useState(false)
  const [apiError, setApiError] = useState('')
  const [topWidgetData, setTopWidgetData] = useState({})
  const [selectedTile, setSelectedTile] = React.useState("notInitiated");
  const [sortBy, setSortBy] = React.useState("WORKer");
  const [sortOrder, setSortOrder] = React.useState(1);
  const [isTileFilter, setIsTileFilter] = React.useState(true);
  const [filterOn, setFilterOn] = React.useState("Filter On");
  const [filterBy, setFilterBy] = React.useState("");
  const [isApplyFilterButtonClicked, setIsApplyFilterButtonClicked] = React.useState(false);
  const [selectedDashBoard, setSelectedDashboard] = React.useState();
  const [refreshTableApi, setRefreshTableApis] = React.useState(true);

  const [isSMP, setIsSMP] = useState(false)
  const [isCaller, setIsCaller] = useState(true)

  const [callerChartData, setCallerChartData] = useState([])
  const [callerChartPage, setCallerChartPage] = useState(1)
  const [refreshCallerChart, setRefreshCallerChart] = useState(false)
  const [selectedCaller, setSelectedCaller] = useState(null)
  const [searchValue, setSearchValue] = useState("")
  const [debouncedSearch, setDebouncedSearch] = useState("")

  // ---- FILTERS dropdown (Lead Status + Lead Response) ----
  const [filterAnchorEl, setFilterAnchorEl] = React.useState(null)
  // working selections inside the popover (keyed by constant value)
  const [leadStatusCheckbox, setLeadStatusCheckbox] = React.useState({ closed: true })
  const [leadResponseCheckbox, setLeadResponseCheckbox] = React.useState({})
  // applied selections that actually drive the API call
  const [statusFilterArray, setStatusFilterArray] = React.useState([])
  const [leadResponseFilterArray, setLeadResponseFilterArray] = React.useState([])

  const isFilterMenuOpen = Boolean(filterAnchorEl)

  // leadResponse constant ids are reversed vs the DB numbers used in the table,
  // so map the constant value -> DB number (matches ChapterLeadsTable rendering).
  const responseValueToDbNumber = {
    vipContact: 7,
    potentialWORKer: 6,
    interestedInKnowledge: 5,
    lowResponse: 4,
    notInterested: 3,
    timeWaste: 2,
    antiAllama: 1,
  }

  const handleFilterButtonClick = (event) => {
    setFilterAnchorEl(event.currentTarget)
  }

  const handleFilterMenuClose = () => {
    setFilterAnchorEl(null)
  }

  const handleLeadStatusCheckbox = (statusValue) => {
    setLeadStatusCheckbox((prev) => {
      const next = { ...prev, [statusValue]: !prev[statusValue] }
      // Lead Response is only valid when Closed is selected. Toggling any
      // status away from Closed (either unchecking Closed, or checking another
      // status which turns Closed off) must immediately clear + disable it.
      if (statusValue !== 'closed') {
        next.closed = false
      }
      if (!next.closed) {
        setLeadResponseCheckbox({})
      }
      return next
    })
  }

  const handleLeadResponseCheckbox = (responseValue) => {
    setLeadResponseCheckbox((prev) => ({
      ...prev,
      [responseValue]: !prev[responseValue],
    }))
  }

  const handleFilterReset = () => {
    setLeadStatusCheckbox({ closed: true })
    setLeadResponseCheckbox({})
    setStatusFilterArray([])
    setLeadResponseFilterArray([])
    setIsTileFilter(true)
    setPage(1)
    setIsApplyFilterButtonClicked(true)
    handleFilterMenuClose()
  }

  const handleApplyFilter = () => {
    const selectedStatuses = Object.entries(leadStatusCheckbox)
      .filter(([, checked]) => checked)
      .map(([value]) => value)

    const selectedResponseNumbers = Object.entries(leadResponseCheckbox)
      .filter(([, checked]) => checked)
      .map(([value]) => responseValueToDbNumber[value])
      .filter((num) => num !== undefined)

    setStatusFilterArray(selectedStatuses)
    setLeadResponseFilterArray(selectedResponseNumbers)
    // dropdown selection takes precedence over the tile filter when active.
    setIsTileFilter(selectedStatuses.length === 0)
    setPage(1)
    setIsApplyFilterButtonClicked(true)
    handleFilterMenuClose()
  }

  const filterHeadingStyle = { fontSize: '1rem', color: red, padding: '0.1rem', fontWeight: 500 }


  const updateRefresh = () => {
    setTableRefresh(!tableRefresh)
  }

  const updatePage = (page) => {
    setPage(page)
    setTableRefresh(!tableRefresh)
  }

  const updateOffset = (offset) => {
    setOffset(offset)
    setPage(1)
    setTableRefresh(!tableRefresh)
  }

  const updateTemplateDialogStatus= () => {
    setTemplateDialogStatus(!templateDialogStatus)
  }

  const updateSMPStatus = () => {
    setIsSMP(() => !isSMP)
    setTableRefresh(!tableRefresh)
  }

  const updateCallerStatus = () => {
    setIsCaller(() => !isCaller)
    setTableRefresh(!tableRefresh)
  }

  const updateCallerPage = (page) => {
    setCallerChartPage(page)
    setRefreshCallerChart(!refreshCallerChart)
  }

  const updateSelectedCaller = (value) => {
    setSelectedCaller(() => value)
  }

  useEffect(() => {
    updatePage(1)
    updateCallerPage(1)
  }, [districts, debouncedSearch])

  // Debounce the search input to avoid making an API call on every keystroke
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchValue)
    }, 500)
    return () => clearTimeout(timer)
  }, [searchValue])


  React.useEffect(() => {
		try {
      if(districts.length > 0){
			setIsLoading(true);
			let options = {
				url: fetchSHDHLeads,
				method: "POST",
				payload: {
          isCaller: isCaller,
          isSMP: isSMP,
					sortBy: sortBy,
					sortOrder: sortOrder,
          districts: districts,
					page: page,
					offset: offset,
					...(isTileFilter && { leadStatusFilter: { $in: [selectedTile] } }),
				},
        
				 headers: {
          headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }
			};

      if(debouncedSearch){
        options.payload.search = debouncedSearch;
      }

      if(localStorage.getItem('designation') === 'admin'){
        options['payload']['gender'] = gender
      }

			if (isTileFilter && selectedTile === "notInitiated") {
				options["payload"]["leadStatusFilter"] = {
					$nin: ["followUp", "notReachable", "closed", "wrongNumber"],
				};
			}

			if (isTileFilter && selectedTile === "attempted") {
				options["payload"]["leadStatusFilter"] = {
					$in: ["followUp", "notReachable", "closed", "wrongNumber"],
				};
			}

			if (isTileFilter && selectedTile === "all") {
				options["payload"]["leadStatusFilter"] = "all";
			}

			// Dropdown FILTERS selection takes precedence over the tile filter.
			if (!isTileFilter && statusFilterArray.length > 0) {
				options["payload"]["leadStatusFilter"] = { $in: statusFilterArray };
			}

			if (leadResponseFilterArray.length > 0) {
				options["payload"]["leadResponseFilter"] = { $in: leadResponseFilterArray };
			}

			if (filterOn != "Filter On") {
				let filterOnValue = "";
				switch (filterOn) {
					case "Lead Name":
						filterOnValue = "name";
						break;
					case "Lead Contact":
						filterOnValue = "contactNumber";
						break;
					case "Phone Name":
						filterOnValue = "phoneName";
						break;
					case "District":
						filterOnValue = "district";
						break;
					case "Chapter":
						filterOnValue = "chapter";
						break;
					default:
						filterOnValue = null;
				}
				options.params.filterOn = filterOnValue;
				options.params.filterBy = filterBy;
			}
			setIsApplyFilterButtonClicked(false);

      if( selectedCaller) {
        options['payload']['caller'] = selectedCaller
      }

			HttpService(options)
				.then((data) => {
					setLeadsData(data?.data?.data);
					setIsLoading(false);
				})
				.catch((err) => {
					setIsLoading(false);
					if (err?.status === 403) {
						localStorage.clear();
						// setLoadingTableData(false)
						navigate("/Login");
					} else {
						// setLoadingTableData(false)
					}
				});
            }
		} catch (err) {
      if(err.status === 403){
          setIsLoading(false)
          navigate('/login')
        } else {
          console.log("Error in fetching Top widget leads: ", err)
          setIsLoading(false);
        }
		}
	}, [
		selectedDashBoard,
		refreshTableApi,
		selectedTile,
		isTileFilter,
		isApplyFilterButtonClicked,
    districts,
    tableRefresh,
    selectedCaller,
    debouncedSearch,
    statusFilterArray,
    leadResponseFilterArray
	]);


  useEffect(() => {
    if(districts.length > 0 && gender.length > 0){
      setIsTopWidgetLoading(true)
      let options = {
        url: getSHDHTopWidget,
        method: 'POST',
        payload: {
          districts: districts
        },
        headers: {
          headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }
      }
      if(localStorage.getItem('designation') === 'admin'){
        options['payload']['gender'] = gender || null
      }

      if( selectedCaller) {
        options['payload']['caller'] = selectedCaller
      }
      HttpService(options).then((resp) => {
        setTopWidgetData(resp?.data?.data)
        setIsTopWidgetLoading(false)
      }).catch(err => {
        if(err.status === 403){
          setIsTopWidgetLoading(false)
          navigate('/login')
        } else {
          setIsTopWidgetLoading(false)
          console.log("Error in fetching Top widget leads: ", err)
        }
      })
    }
  }, [districts, gender, selectedCaller])
  
  const handleSelectedTile = (tileValue) => {
		setPage(1);
		setSelectedTile(() => tileValue);
	};

  useEffect(() => {
    if(gender && gender.length > 0 && districts && districts.length > 0 && selectedTile){
      let options = {
        url: getCallerPerformance,
        method: 'POST',
        payload: {
          page: callerChartPage,
          districts: districts
        },
        headers: {
          headers: 
          {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }
      }

      if( selectedTile === 'notInitiated'){
        options['payload']['status'] = ['']
      } else if(selectedTile === 'attempted' || selectedTile === 'all'){
        options['payload']['status'] = ['closed', 'notReachable', 'wrongNumber', 'followUp']
      }else {
        options['payload']['status'] = [selectedTile]
      }

      if( localStorage.getItem('designation') === 'admin'){
        // console.log("Gender: ", gender)
        // if(gender === 'all'){
        //   options['payload']['gender'] = ['Male', 'Female']
        // } else if(gender === 'Male'){
        //   options['payload']['gender'] = ['Male']
        // } else if(gender === 'Female'){
          
        // }
        options['payload']['gender'] = gender
      }

      if( selectedCaller){
        options['payload']['caller'] = selectedCaller
      }
      
      HttpService(options).then((result) => {
        setCallerChartData(() => result?.data?.data)
      }).catch(err => {
        console.log('Error in fetching caller performance: ', err)
        setApiError(() =>  'Error in fetching Caller Data. Please Contact Support.')
      })
    }
  }, [selectedTile, refreshCallerChart, districts, gender, selectedCaller])

  const filterMenu = (
    <>
      <Button
        variant="outlined"
        onClick={handleFilterButtonClick}
        sx={{
          backgroundColor: pureWhite,
          color: headingBlue,
          border: `1px solid ${headingBlue}`,
          padding: '0.2rem 0.8rem 0.2rem 0.8rem',
          marginRight: '0.5rem',
        }}
      >
        Filters
      </Button>
      <Popover
        open={isFilterMenuOpen}
        anchorEl={filterAnchorEl}
        onClose={handleFilterMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '300px',
            maxHeight: '90vh',
            overflowY: 'auto',
            scrollbarWidth: 'none',
          }}
        >
          <Box sx={{ padding: '1rem 1rem 0rem 1rem' }}>
            <Typography style={filterHeadingStyle}>Lead Status</Typography>
            <Box>
              {leadStatus.map((status) => (
                <FilterCheckbox
                  key={status.id}
                  label={status.title}
                  checked={leadStatusCheckbox[status.value]}
                  onToggle={() => handleLeadStatusCheckbox(status.value)}
                />
              ))}
            </Box>
          </Box>
          <Box sx={{ padding: '1rem' }}>
            <Typography style={filterHeadingStyle}>Lead Response</Typography>
            <Box>
              {leadResponse.map((response) => (
                <FilterCheckbox
                  key={response.id}
                  label={response.title}
                  checked={leadResponseCheckbox[response.value]}
                  onToggle={() => handleLeadResponseCheckbox(response.value)}
                  disabled={!leadStatusCheckbox?.closed}
                />
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              gap: '0.5rem',
              backgroundColor: pureWhite,
              borderTop: '1px solid #ddd',
              position: 'sticky',
              bottom: 0,
              padding: '0.6rem 1rem 0.9rem 1rem',
            }}
          >
            <Button
              variant="outlined"
              style={{
                fontSize: '0.7rem',
                padding: '0.3rem 0.6rem 0.3rem 0.6rem',
                color: headingBlue,
                backgroundColor: pureWhite,
                border: '1px solid',
                borderRadius: '0.4rem',
              }}
              onClick={handleFilterReset}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyle, fontSize: '0.7rem', padding: '0.4rem 0.6rem 0.4rem 0.6rem' }}
              onClick={handleApplyFilter}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  )

  return (
      <>
      <DashboardsTopDropDowns
        templateDialogStatus = {templateDialogStatus}
        updateTemplateDialogStatus= {updateTemplateDialogStatus}
        filterMenu = {filterMenu}
      ></DashboardsTopDropDowns>
      <Box style={{overflow: 'auto', padding: "0.5rem 1.5rem 1.5rem 1.5rem"}}>
        {(isLoading || isTopWidgetLoading)&& <Loader></Loader>}
        <Box style={{display: 'flex', width: '90%', padding: '0.1rem 0.3rem 0.3rem 0.3rem'}}>
          {selectedCaller && 
            <Chip label={selectedCaller} 
              onDelete={() =>{
                setSelectedCaller(() => null)
              }}
            >
            </Chip>
          }

        </Box>
        <Grid container spacing = {2}>
          <Grid item xs={6} sm = {1.7} onClick={() => handleSelectedTile("all")}>
            <TopCard 
              heading="All Leads"
              color={hMapBlue}
              data={topWidgetData['total']}
              isSelected={selectedTile === "all"}
              isSmall={true}
            >
            </TopCard>
          </Grid>
          <Grid item xs={6} sm = {1.7} onClick={() => handleSelectedTile("attempted")}>
            <TopCard heading="Attempted"
              color={hMapBlue}
              data={topWidgetData['attempted']}
              isSelected={selectedTile === "attempted"}
							isSmall={true}
            >
              
            </TopCard>
          </Grid>
          <Grid item xs={6} sm = {1.7} onClick={() => handleSelectedTile("notInitiated")}>
            <TopCard 
              heading="Not Initiated"
              color={hMapBlue}
              data={topWidgetData['notInitiated']} 
              isSelected={selectedTile === "notInitiated"}
							isSmall={true}
            >  
            </TopCard>
          </Grid>
          <Grid item xs={6} sm = {1.7} onClick={() => handleSelectedTile("followUp")}>
            <TopCard heading="Follow Up"
              color={yellowish}
              data={topWidgetData['followUp']}
              isSelected={selectedTile === "followUp"}
              isSmall={true}
            >
            </TopCard>
          </Grid>
          <Grid item xs={6} sm = {1.7} onClick={() => handleSelectedTile("notReachable")}>
            <TopCard heading="Not Reachable"
              color={orange}
              data={topWidgetData['notReachable']}  
              isSelected={selectedTile === "notReachable"}
              isSmall={true}
            >
            </TopCard>
          </Grid>
          <Grid item xs={6} sm = {1.7} onClick={() => handleSelectedTile("wrongNumber")}>
            <TopCard heading="Wrong Number"
              color={maroon}
              data={topWidgetData['wrongNumber']}
              isSelected={selectedTile === "wrongNumber"}
              isSmall={true}
            >
            </TopCard>
          </Grid>
          <Grid item xs={6} sm = {1.7} onClick={() => handleSelectedTile("closed")}>
            <TopCard heading="Closed"
              color={green}
              data={topWidgetData['closed']}
              isSelected={selectedTile === "closed"}
              isSmall={true}
            >
            </TopCard>
          </Grid>

        </Grid>
        <Box style={{padding: '1.5rem 0.2rem 0.5rem 0.2rem'}}>
          <HBChart data={callerChartData} 
            xValue='name' 
            yValue='score' 
            seriesValue='Score'
            page={callerChartPage}
            updatePage={updateCallerPage}
            updateCaller = {updateSelectedCaller}
          ></HBChart>
        </Box>
        <ChapterLeadsTable
          pageValue={page}
          updatePage={updatePage}
          offsetValue={offset}
          updateOffset = {updateOffset}
          data={leadsData}
          updateRefresh = {updateRefresh}
          apiError={apiError}  
          isSMP={isSMP}
          updateSMPStatus={updateSMPStatus}
          isCaller={isCaller}
          updateCallerStatus={updateCallerStatus}
          searchValue={searchValue}
          updateSearchValue={setSearchValue}
        >
        </ChapterLeadsTable>

      </Box>
      <LeadTemplates dialogStatus = {templateDialogStatus} updateDialogStatus= {updateTemplateDialogStatus}></LeadTemplates>
      </>
    )
}

const FilterCheckbox = ({ label, checked, onToggle, disabled }) => {
  return (
    <Box style={{ display: 'flex', alignItems: 'center' }}>
      <Checkbox
        checked={checked || false}
        style={{ padding: '0rem 0.1rem 0rem 0.1rem' }}
        onChange={onToggle}
        disabled={disabled}
      />
      <Typography sx={{ fontSize: '0.9rem', color: headingBlue }}>{label}</Typography>
    </Box>
  )
}

export default ChapterLeads
